import { Box, MenuItem, TextField } from '@mui/material';
import '../../styles/theLook.scss';
import { useState } from 'react';
import { Button } from '../button';
import { useNavigate } from 'react-router-dom';

const setBowOrTie = [
	'Bow', 'Tie'
];

const setWaistOrSuspender = [
	'Waistcoat', 'Suspenders'
];

const setShoes = [
	'Mate', 'Shining'
];

export const TheLook = () => {
	const [selectBowOrTie, setSelectBowOrTie] = useState('');
	const [selectWaistOrSuspender, setSelectWaistOrSuspender] = useState('');
	const [selectShoes, setSelectShoes] = useState('');
	const navigate = useNavigate();

	const handleNext = () => {
		navigate('/the-measurements');
	};

	return (
		<div className='the-look'>
			<div className='the-look-container'>
				<div className='img-look'>1</div>
				<div className='set-the-look'>
					<h2>The Look</h2>
					<Box>
						<TextField
							sx={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}
							select
							label='Select bow or tie'
							value={selectBowOrTie}
							onChange={(e: any) => setSelectBowOrTie(e.target.value)}
							variant='outlined'
						>
							{setBowOrTie.map((item, index) => (
								<MenuItem key={index} value={item}>{item}</MenuItem>
							))}
						</TextField>
						<TextField
							sx={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}
							select
							label='Select waistcoat or suspenders'
							value={selectWaistOrSuspender}
							onChange={(e: any) => setSelectWaistOrSuspender(e.target.value)}
							variant='outlined'
						>
							{setWaistOrSuspender.map((item, index) => (
								<MenuItem key={index} value={item}>{item}</MenuItem>
							))}
						</TextField>
						<TextField
							sx={{ width: '100%', maxWidth: '400px', marginBottom: '20px' }}
							select
							label='Select shoes'
							value={selectShoes}
							onChange={(e: any) => setSelectShoes(e.target.value)}
							variant='outlined'
						>
							{setShoes.map((item, index) => (
								<MenuItem key={index} value={item}>{item}</MenuItem>
							))}
						</TextField>
					</Box>
						 <Button 
							onClick={handleNext} 
							text='Next'
						></Button>				
				</div>
			</div>
		</div>
	)
}
